<template>
  <div class="bigTitle">
    <div class="width1000 margintb">

      <h3 v-for="(item,index) in dataList.data"
          :key="index">
        <a v-if="item.dataType=='article'"
           :href="'/h5/detail.html?artId='+item.dataVal"
           target="_blank ">{{item.title}}</a>
        <a v-else
           :href="item.dataVal"
           target="_blank ">{{item.title}}</a>
      </h3>

    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  props: ['dataList'],
  watch: {
    dataList (val) {
      this.dataList = val;
    }
  }
}
</script>
<style lang="less">
.bigTitle {
  text-align: center;
  h3 {
    font-size: 24px;
    font-weight: 800;
    line-height: 30px;
  }
  .margintb {
    margin: 24px auto;
  }
}
</style>
